module.exports = __webpack_public_path__ + "img/cash-pay.10564063.svg";